import { Auth } from '@grammarly/identity-ui'

export const SessionStorageKey = {
  // Used to auto-start login flow on /signin if these values are set
  loginHint: Auth.SignupSigninEmail.LoginHint,
  loginHintType: Auth.SignupSigninEmail.LoginHintType,

  // Fullstory
  persistFullStoryJS: 'persistFullStoryJS',

  // G2A-1953: Text content to be transferred to AI Editor after authentication
  editorContent: 'editorContent',

  // G2A-2037: tool type the user was using in their session.
  toolLastUsed: 'toolLastUsed',
} as const

export type StaticSessionStorageKeyType = (typeof SessionStorageKey)[keyof typeof SessionStorageKey]

export type BannerTrackingIdType = string

export type SessionStorageKeyType = StaticSessionStorageKeyType | BannerTrackingIdType

export const isSessionStorageSupported: boolean = !!IS_CLIENT_SIDE && window.sessionStorage != null

export const setSessionStorageItem = (key: SessionStorageKeyType, value: string) => {
  if (!isSessionStorageSupported) {
    return
  }
  try {
    sessionStorage.setItem(key, value)
  } catch (err) {
    // can throw if storage is full
  }
}

export const removeSessionStorageItem = (key: SessionStorageKeyType) => {
  return isSessionStorageSupported && sessionStorage.removeItem(key)
}

export const getSessionStorageItem = (key: SessionStorageKeyType, removeItem = false) => {
  const result = isSessionStorageSupported ? sessionStorage.getItem(key) : null
  if (removeItem) {
    removeSessionStorageItem(key)
  }
  return result
}
